import React, { useCallback } from 'react'
import { Trans } from 'react-i18next'
import { useBoolean } from 'react-use'
import uniqueId from 'lodash/uniqueId'
import { v4 as uuid4 } from 'uuid'

import {
  IActionRepeaterValue,
  IActionType,
  VariableActionOption,
  VariableResultAvatar,
  VariableSelectFeatureFlag,
} from '@makyoapp/makyo-common'
import { PersonalCard16 } from '@makyoapp/makyo-icon/icon'

import { VariableSimpleAction } from './VariableSimpleAction'
import { VariableWrapper } from './VariableWrapper'

interface VariableAvatarProps {
  id?: string
  onChange: (value: VariableResultAvatar) => void
  actionType?: VariableActionOption
}

export default function VariableAvatar({ id = uniqueId('va-'), onChange, actionType }: VariableAvatarProps) {
  const [show, setShow] = useBoolean(false)

  return (
    <VariableWrapper
      title={<Trans>Avatar</Trans>}
      icon={<PersonalCard16 />}
      show={show}
      setShow={setShow}
      onToggle={setShow}
      defaultMenuPad={false}
    >
      <VariableAvatarBody
        id={id}
        value={{
          id: uuid4(),
          flag: VariableSelectFeatureFlag.Avatar,
          actions: undefined,
        }}
        setShow={setShow}
        onDone={onChange}
        action={actionType}
      />
    </VariableWrapper>
  )
}

export function VariableAvatarBody({
  value,
  id,
  action,
  onDone,
  setShow,
}: {
  value: VariableResultAvatar
  id?: string
  onDone: (value: VariableResultAvatar) => void
  action?: VariableActionOption
  setShow: (next: boolean) => void
}) {
  const onActionDone = useCallback(
    (actionValue?: Omit<IActionRepeaterValue, 'id'> | IActionRepeaterValue[]) => {
      const nextValue: VariableResultAvatar = {
        id: value.id,
        flag: VariableSelectFeatureFlag.Avatar,
        actions: actionValue,
      }
      onDone(nextValue)
      setShow(false)
    },
    [setShow, onDone, value.id]
  )

  return (
    <>
      {action === VariableActionOption.Simple && (
        <div className='p-2 flex flex-col gap-2'>
          <VariableSimpleAction
            id={`${id ?? uniqueId('vsa-')}-avatar-action`}
            value={(typeof value.actions === 'object' ? value.actions : undefined) as Omit<IActionRepeaterValue, 'id'>}
            actionTypes={[
              IActionType.GoBack,
              IActionType.GoToScreen,
              IActionType.RefreshScreen,
              IActionType.OpenNavDrawer,
              IActionType.Logout,
              IActionType.OpenLink,
              IActionType.OpenMap,
              IActionType.OpenMenu,
            ]}
            onDone={onActionDone}
          />
        </div>
      )}
      {action === VariableActionOption.Advanced && <div>Not Available Yet!</div>}
    </>
  )
}
